"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = void 0;

var _react = require("@emotion/react");

var _util = require("../../util");

var normal = function normal(theme) {
  return /*#__PURE__*/(0, _react.css)("display:inline-flex;align-items:center;line-height:", theme.lineHeight.leadingNormal, ";background-color:", theme.color.tag.bg, ";padding:2px ", theme.spacing['5'], " 3px;border-radius:4px;button{cursor:pointer;display:flex;align-items:center;color:", theme.color.tag.closeIcon, ";opacity:0.5;margin-left:", (0, _util.rem)(4), ";&:hover{color:", theme.color.tag.closeIconHover, ";opacity:1;}}svg{width:", (0, _util.rem)(16), ";height:", (0, _util.rem)(16), ";margin-bottom:-1px;}" + (process.env.NODE_ENV === "production" ? "" : ";label:normal;"));
};

var small = function small(theme) {
  return /*#__PURE__*/(0, _react.css)(normal(theme), ";font-size:", theme.fontSize.tiny, ";border-radius:3px;" + (process.env.NODE_ENV === "production" ? "" : ";label:small;"));
};

var email = function email(theme) {
  return /*#__PURE__*/(0, _react.css)(normal(theme), ";color:", theme.color.emailBox.text, ";font-size:", theme.fontSize.small, ";border-radius:6px;button{color:", theme.color.tag.closeIcon, ";&:hover{cursor:pointer;color:", theme.color.tag.closeIconHover, ";}}" + (process.env.NODE_ENV === "production" ? "" : ";label:email;"));
};

var error = function error(theme) {
  return /*#__PURE__*/(0, _react.css)("background-color:", theme.color.emailBox.errorBg, ";color:", theme.color.emailBox.errorText, ";button{color:", theme.color.emailBox.closeIconError, ";opacity:0.8;&:hover{opacity:1;color:inherit;}}" + (process.env.NODE_ENV === "production" ? "" : ";label:error;"));
};

var styles = {
  normal: normal,
  small: small,
  email: email,
  error: error
};
exports.styles = styles;
//# sourceMappingURL=Tag.styles.js.map